module.exports = __webpack_public_path__ + "book_cover.png?60702166ff874ade530b23832c57891b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/book_cover.png
// module id = 23
// module chunks = 0